import PropTypes from 'prop-types'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cn } from '@tiptap-ui/lib/tiptap-utils'
import '@tiptap-ui/components/tiptap-ui-primitive/popover/popover.scss'

function Popover ({
  ...props
}) {
  return <PopoverPrimitive.Root {...props} />
}

Popover.propTypes = {
  // Radix Root accepts various props; allow generic object
}

function PopoverTrigger ({
  ...props
}) {
  return <PopoverPrimitive.Trigger {...props} />
}

PopoverTrigger.propTypes = {
  // generic pass-through
}

function PopoverContent ({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn('tiptap-popover', className)}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}

PopoverContent.propTypes = {
  className: PropTypes.string,
  align: PropTypes.string,
  sideOffset: PropTypes.number,
}

export { Popover, PopoverTrigger, PopoverContent }
